import list from './list';
import edit from './edit';
import create from './create';
import { isAdmin, isSuperAdmin } from 'utils';

export default (permissions) => {
  const isVisible = isSuperAdmin(permissions) || isAdmin(permissions);
  return {
    name: 'event',
    list,
    edit,
    create: isVisible ? create : null,
    icon: 'book-open',
    options: {
      menuIndex: 3,
    },
  };
};
